<div class="auth">
  <div class="login-form">
    <div class="logo">
      <img src="../../assets/cissplogo.png" alt="CISSP" />
    </div>
    <h3>
      <span>Enter your authentication code</span> Use your authenticator app to
      view your security code
    </h3>
    <div class="form" [formGroup]="AuthForm">
      <div class="input-form mb-20">
        <input
          type="password"
          name="password"
          formControlName="newpass"
          [(ngModel)]="newpass"
          class="input"
          placeholder="Enter new password"
        />
        <span class="material-icons"> more_horiz </span>
      </div>
      <div class="input-form mb-20">
        <input
          type="password"
          name="auth"
          formControlName="Authcode"
          [(ngModel)]="Authcode"
          class="input"
          placeholder="Authentication code"
        />
        <span class="material-icons"> more_horiz </span>
      </div>
    </div>
    <button type="submit" class="submit" (click)="ConfimCode()">
      Confirm Password
    </button>
  </div>
</div>
<ngx-spinner
  bdColor="#00041aa6"
  size="default"
  color="##d7779b"
  template="<img src='../../../assets/images/loading.gif' class='loading-indicator'/>"
  [fullScreen]="true"
>
</ngx-spinner>
